import React from "react";
import {save} from 'save-file'
import {ReactSession} from "react-client-session";
import {
    Button,
    CardContent,
    Checkbox,
    Collapse,
    Divider,
    FormHelperText,
    FormLabel,
    Grid,
    MenuItem,
    Select,
    Typography
} from '@mui/material'

import {Card} from "react-bootstrap";
import {loading} from "./loading";
import TableCtrNeg from "./tabelle/Table";
import FiltroSceltaNegozio from "./filtri/FiltroSceltaNegozio";
import FiltriArticoliINV, {dammiArticoli} from "./filtri/FiltriArticoliINV";

import ctrprezziicon from "../img/articoli/ctrprezziicon.png";
import inventarioicon from "../img/articoli/inventarioicon.png";
import axios from "axios";
import VariabiliGlobali from "../Back/VariabiliGlobali";
import NessunRisultato from "./NessunRisultato";
import theme from "../theme";


export class Articoli extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            doveMiTrovo: 'articoli',
            sceltanegozio: 'Tutti',
            inventario: [],
            ctrPrezzi: [],
            imponibili: false,
            descrizione: "",
            marca: "",
            reparto: "0",
            soloReparti: false,
            soloDiversi: false,
            filtroGiac: 'Giacenza > 0',
            filtroSceltaPreMag: 'Prezzo vendita',
            filtroSceltaPreNeg: 'Prezzo vendita',
            ricercaEffettuata: false,
            open: false,
            promo: "0",
            idpromo: "0",
            testoFiltriAvanzati: "Mostra filtri avanzati",
            arrVAR: [false, "0001-01-01", "0001-01-01", '0', '', '', '0', '', '0'],
        };
        this.idmagazzino = ReactSession.get("idmagazzino");
    }

    componentDidMount() {
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cambiaNegozio = this.cambiaNegozio.bind(this);
        this.resettaFiltri = this.resettaFiltri.bind(this);
        this.handleChangeArticolo = this.handleChangeArticolo.bind(this);
    }

    cambiaNegozio(variabile) {
        this.setState({sceltanegozio: variabile})
    }

    handleChangeArticolo(descrizione, marca, reparto, promo, arrVAR,idpromo) {
        this.setState({descrizione: descrizione})
        this.setState({marca: marca})
        this.setState({reparto: reparto})
        this.setState({arrVAR: arrVAR})
        this.setState({promo: promo})
        this.setState({idpromo: idpromo})
    }

    resettaFiltri() {
        this.setState({descrizione: ""})
        this.setState({marca: ""})
        this.setState({reparto: "0"})
        this.setState({soloReparti: false})
        this.setState({soloDiversi: false})
        this.setState({filtroGiac: 'Giacenza > 0'})
        this.setState({filtroSceltaPreMag: 'Prezzo vendita'})
        this.setState({filtroSceltaPreNeg: 'Prezzo vendita'})
        this.setState({promo: "0"})
        this.setState({imponibili: false})
        this.setState({arrVAR: [false, "0001-01-01", "0001-01-01", '0', '', '', '0', '', '0']});
    }

    handleChange(event, provenienza) {
        if (provenienza === 'inventario') {
            this.setState({doveMiTrovo: 'inventario'})
        }
        if (provenienza === 'ctrPrezzi') {
            this.setState({doveMiTrovo: 'ctrPrezzi'})
        }
        if (provenienza === 'imponibili') {
            if (this.state.imponibili === true) {
                this.setState({imponibili: false});
            } else {
                this.setState({imponibili: true});
            }
        }
        if (provenienza === 'soloReparti') {
            if (this.state.soloReparti === true) {
                this.setState({soloReparti: false});
            } else {
                this.setState({soloReparti: true});
            }
        }
        if (provenienza === 'soloDiversi') {
            if (this.state.soloDiversi === true) {
                this.setState({soloDiversi: false});
            } else {
                this.setState({soloDiversi: true});
            }
        }
        if (provenienza === 'filtroGiac') {
            this.setState({filtroGiac: event.target.value});
        }
        if (provenienza === 'filtroSceltaPreMag') {
            this.setState({filtroSceltaPreMag: event.target.value});
        }
        if (provenienza === 'filtroSceltaPreNeg') {
            this.setState({filtroSceltaPreNeg: event.target.value});
        }
        if (provenienza === 'btnOpen') {
            this.setState({open: !this.state.open})
            if (this.state.open.toString() !== "true") {
                this.setState({testoFiltriAvanzati: "Nascondi filtri avanzati"})
            } else {
                this.setState({testoFiltriAvanzati: "Mostra filtri avanzati"})
            }
        }
    }

    async generaTERM01(event, ctrPrezzi) {
        try {
            event.preventDefault();
            let buff = "";
            for (let i = 0; i < ctrPrezzi.length; i++) {
                let element = ctrPrezzi[i];
                buff += element.ID + "|1\n";
            }
            await save(Buffer.from(buff), "TERM01.DAT")
        } catch (e) {
            alert(e)
        }
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.doveMiTrovo === 'inventario') {
            this.setState({loading: true})
            let sceltanegozio = this.state.sceltanegozio
            let filtro_giac = this.state.filtroGiac
            let imponibili = this.state.imponibili
            let soloReparti = this.state.soloReparti
            let articoli = "";
            if (sceltanegozio.toString().toUpperCase() !== 'TUTTI') {
                articoli = await dammiArticoli(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, this.state.arrVAR, sceltanegozio,this.state.idpromo)
            } else {
                articoli = await dammiArticoli(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, this.state.arrVAR, '0',this.state.idpromo)
            }
            const params = new URLSearchParams();
            params.append('sceltanegozio', sceltanegozio);
            params.append('filtro_giac', filtro_giac);
            params.append('imponibili', imponibili);
            params.append('soloReparti', soloReparti);
            params.append('articoli', articoli);
            params.append('idmagazzino', this.idmagazzino);
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/DammiInventario';
            axios.post(url, params, config)
                .then((response) => {
                    this.setState({inventario: ''});
                    this.setState({inventario: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })
        }
        if (this.state.doveMiTrovo === 'ctrPrezzi') {
            this.setState({loading: true})
            let sceltanegozio = this.state.sceltanegozio
            let articoli = "";
            if (sceltanegozio.toString().toUpperCase() !== 'TUTTI') {
                articoli = await dammiArticoli(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, this.state.arrVAR, sceltanegozio)
            } else {
                articoli = await dammiArticoli(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, this.state.arrVAR, '0')
            }
            let filtroSceltaPreMag = this.state.filtroSceltaPreMag
            let filtroSceltaPreNeg = this.state.filtroSceltaPreNeg
            let imponibili = this.state.imponibili
            let soloDiversi = this.state.soloDiversi
            let filtro_giac = this.state.filtroGiac
            const params = new URLSearchParams();
            params.append('sceltanegozio', sceltanegozio);
            params.append('articoli', articoli);
            params.append('filtroSceltaPreMag', filtroSceltaPreMag);
            params.append('filtroSceltaPreNeg', filtroSceltaPreNeg);
            params.append('imponibili', imponibili);
            params.append('soloDiversi', soloDiversi);
            params.append('filtro_giac', filtro_giac);
            params.append('idmagazzino', this.idmagazzino)

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/DammiCtrPrezzi';
            axios.post(url, params, config)
                .then((response) => {
                    this.setState({ctrPrezzi: ''});
                    this.setState({ctrPrezzi: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })
        }
        this.setState({ricercaEffettuata: true})
    }


    landing() {
        return (
            <div>
                <Grid className="center" container direction="column" spacing={3}>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="inventarioicon"
                                     onClick={(e) => this.handleChange(e, "inventario")}
                                     src={inventarioicon}
                                     alt=" "
                                     className="d-inline-block align-top"/> </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="ctrprezziicon"
                                     onClick={(e) => this.handleChange(e, "ctrPrezzi")}
                                     src={ctrprezziicon}
                                     alt=" "
                                     className="d-inline-block align-top"/> </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }

    ctrPrezzi() {
        return (
            <div>
                <div>
                    <Grid container direction="column" spacing={3}>
                        <Grid item>
                            <Card className="center" sx={{minWidth: 275}} spacing={3}>
                                <FiltroSceltaNegozio
                                    visualizzaMaga={false}
                                    sceltaneg={"Tutti"}
                                    visualizzaTutti={true}
                                    cambiaNegozio={this.cambiaNegozio}
                                />
                            </Card>
                        </Grid>
                        <Grid item>
                            <FiltriArticoliINV
                                descrizione=""
                                marca=""
                                reparto="0"
                                filtroGiac="0"
                                promo="0"
                                arrVAR={this.state.arrVAR}
                                handleChangeArticolo={this.handleChangeArticolo}
                                resettaFiltri={this.resettaFiltri}
                                idpromo=""
                            />
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" spacing={3}>
                                <Grid item>
                                    <Grid item>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="filtroSceltaPreMag"
                                            value={this.state.filtroSceltaPreMag}
                                            label=''
                                            onChange={(e) => this.handleChange(e, "filtroSceltaPreMag")}>
                                            <MenuItem value={"Prezzo vendita"}>Prezzo vendita</MenuItem>
                                            <MenuItem value={"Prezzo 2"}>Prezzo 2</MenuItem>
                                            <MenuItem value={"Prezzo 3"}>Prezzo 3</MenuItem>
                                        </Select>
                                        <FormHelperText>Prezzo magazzino</FormHelperText>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="filtroSceltaPreNeg"
                                        value={this.state.filtroSceltaPreNeg}
                                        label=''
                                        onChange={(e) => this.handleChange(e, "filtroSceltaPreNeg")}>
                                        <MenuItem value={"Prezzo vendita"}>Prezzo vendita</MenuItem>
                                        <MenuItem value={"Prezzo 2"}>Prezzo 2</MenuItem>
                                        <MenuItem value={"Prezzo 3"}>Prezzo 3</MenuItem>
                                    </Select>
                                    <FormHelperText>Prezzo negozio</FormHelperText>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" onClick={(e) => this.handleChange(e, "btnOpen")}>
                                        {this.state.testoFiltriAvanzati}
                                    </Button>
                                    <Collapse in={this.state.open}>
                                        <div className="elemento">
                                            <Grid item>
                                                <FormLabel component="legend">
                                                    <Checkbox
                                                        value={this.state.imponibili}
                                                        onChange={(e) => this.handleChange(e, "imponibili")}
                                                    />Prezzi imponibili
                                                </FormLabel>
                                            </Grid>
                                            <Grid item>
                                                <FormLabel component="legend">
                                                    <Checkbox
                                                        value={this.state.soloDiversi}
                                                        onChange={(e) => this.handleChange(e, "soloDiversi")}
                                                    />
                                                    Visualizza solo diversi
                                                </FormLabel>
                                            </Grid>
                                            {/*
                                            <Grid item>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="filtroGiac"
                                                    value={this.state.filtroGiac}
                                                    label=''
                                                    onChange={(e) => this.handleChange(e, "filtroGiac")}>
                                                    <MenuItem value={"Giacenza > 0"}>Giacenza > 0</MenuItem>
                                                    <MenuItem value={"Tutti"}>Tutti </MenuItem>
                                                    <MenuItem value={"Giacenza negativa"}>Giacenza negativa</MenuItem>
                                                    <MenuItem value={"Giacenza diversa da zero"}>Giacenza diversa da
                                                        zero</MenuItem>
                                                </Select>
                                                <FormHelperText>Filtro giacenza</FormHelperText>
                                            </Grid>
                                            */}
                                        </div>
                                    </Collapse>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                    onClick={this.handleSubmit}>Avvia
                                ricerca</Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                    onClick={(e) => this.generaTERM01(e, this.state.ctrPrezzi)}>Genera
                                TERM01.DAT</Button>
                        </Grid>
                    </Grid>
                    {this.state.loading === true ? (
                        <div>
                            {loading()}
                        </div>
                    ) : (
                        <div className='elemento'>
                            {this.state.ctrPrezzi.length > 0 && (
                                <div>
                                    <Divider/>
                                    <TableCtrNeg data={this.state.ctrPrezzi}/>
                                </div>
                            )}
                            {this.state.ctrPrezzi.length === 0 && this.state.ricercaEffettuata && (
                                <NessunRisultato/>
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }

    inventario() {
        return (
            <div>
                <div>
                    <Grid container direction="column" spacing={3}>
                        <Grid item>
                            <Card className="center" sx={{minWidth: 275}} spacing={3}>
                                <FiltroSceltaNegozio
                                    visualizzaMaga={true}
                                    sceltaneg={"Tutti"}
                                    visualizzaTutti={true}
                                    cambiaNegozio={this.cambiaNegozio}
                                />
                            </Card>
                        </Grid>
                        <Grid item>
                            <FiltriArticoliINV
                                descrizione=""
                                marca=""
                                reparto="0"
                                filtroGiac="0"
                                promo="0"
                                arrVAR={this.state.arrVAR}
                                handleChangeArticolo={this.handleChangeArticolo}
                                resettaFiltri={this.resettaFiltri}
                                idpromo=""
                            />
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" spacing={3}>
                                <Grid item>
                                    <FormLabel component="legend">
                                        <Checkbox
                                            value={this.state.imponibili}
                                            onChange={(e) => this.handleChange(e, "imponibili")}
                                        />Prezzi imponibili
                                    </FormLabel>
                                </Grid>
                                <Grid item>
                                    <FormLabel component="legend">
                                        <Checkbox
                                            label="Solo Reparti"
                                            value={this.state.soloReparti}
                                            onChange={(e) => this.handleChange(e, "soloReparti")}
                                        />
                                        Visualizza solo reparti
                                    </FormLabel>
                                </Grid>
                                <Grid item>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="filtroGiac"
                                        value={this.state.filtroGiac}
                                        label=''
                                        onChange={(e) => this.handleChange(e, "filtroGiac")}>
                                        <MenuItem value={"Giacenza > 0"}>Giacenza > 0</MenuItem>
                                        <MenuItem value={"Tutti"}>Tutti </MenuItem>
                                        <MenuItem value={"Giacenza negativa"}>Giacenza negativa</MenuItem>
                                        <MenuItem value={"Giacenza diversa da zero"}>Giacenza diversa da zero</MenuItem>
                                        <MenuItem value={"Giacenza = 0"}>Giacenza = 0</MenuItem>
                                    </Select>
                                    <FormHelperText>Filtro giacenza</FormHelperText>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                    onClick={this.handleSubmit}>Avvia
                                ricerca</Button>
                        </Grid>
                    </Grid>
                    {this.state.loading === true ? (
                        <div>
                            {loading()}
                        </div>
                    ) : (
                        <div className='elemento'>
                            {this.state.inventario.length > 0 && (
                                <div>
                                    <Divider/>
                                    <TableCtrNeg data={this.state.inventario}/>
                                </div>
                            )}
                            {this.state.inventario.length === 0 && this.state.ricercaEffettuata && (
                                <NessunRisultato/>
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }

    render() {
        return (
            <div>
                {this.state.doveMiTrovo === 'articoli' && (
                    <div>
                        {this.landing()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'inventario' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>INVENTARIO </Typography>
                        </Card>
                        <br/>
                        {this.inventario()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'ctrPrezzi' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>CONTROLLO PREZZI </Typography>
                        </Card>
                        <br/>
                        {this.ctrPrezzi()}
                    </div>
                )}
            </div>
            //<form action="" method="post">

        )
    }

}
